import { render, staticRenderFns } from "./ApplySetting.vue?vue&type=template&id=2396fa77&scoped=true&"
import script from "./ApplySetting.vue?vue&type=script&lang=ts&"
export * from "./ApplySetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396fa77",
  null
  
)

export default component.exports